<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_coupon.webp`)">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          クーポン
        </h1>

        <h2 class="subheading fs_15px">
          勝winでは不定期にクーポンコードを配付しており、<br>
          お客様はEメールまたは勝winの<br>
          公式SNSなどで各種クーポンコードを獲得いただけます。
        </h2>

        <hr class="hr_line my_5r">

        <h1 class="main-title">
          クーポンを交換する
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': isActive}" @click="toggleActive">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !isActive}" @click="toggleActive">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「ショップ」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/coupon_pc_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1. クーポンタブをタップし<br>
                2. 空欄に交換コードを入力
              </h2>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6">
                「引換」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/coupon_pc_tab_02.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「ショップ」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/coupon_mb_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1. クーポンタブをタップし<br>
                2. 空欄に交換コードを入力
              </h2>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6">
                「引換」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/coupon_mb_tab_02.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>
